// extracted by mini-css-extract-plugin
export var statItem = "_mc-1";
export var statsRow = "_mc-0";